import { LoadingStates } from '@pb/utils'

import UnreviewedsState from './types'

const initialState: UnreviewedsState = {
  unreviewedProducts: [],
  totalNumberOfUnreviewedProducts: 0,
  creatingReviewSubmitted: false,
  headerStatus: 'normal',
  loadingUnreviewedProductsStatus: LoadingStates.NotLoaded,
}

export default initialState
